import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/http-services/auth.service';
import { SignedInUser } from '../../models/signin.model';

@Component({
  selector: 'app-two-factors-code',
  templateUrl: './two-factors-code.component.html',
  styleUrls: ['./two-factors-code.component.css']
})
export class TwoFactorsCodeComponent implements OnInit {

  @Input()
  signedInUser: SignedInUser;

  @Input()
  email: string;

  @Input()
  phone: string;

  @Output()
  isCodeValidate: EventEmitter<boolean> = new EventEmitter<boolean>();

  isValid: boolean = true;

  code1: string = '';
  code2: string = '';
  code3: string = '';
  code4: string = '';
  isCodeMismatch: boolean = false;
  @ViewChild('codeCtrl1') codeCtrl1: ElementRef;
  @ViewChild('codeCtrl2') codeCtrl2: ElementRef;
  @ViewChild('codeCtrl3') codeCtrl3: ElementRef;
  @ViewChild('codeCtrl4') codeCtrl4: ElementRef;

  constructor(public activeModal: NgbActiveModal,
    private authService: AuthService) { }

  ngOnInit(): void {
  }

  validateCode() {

  }

  onKeyUp(event: any, code: string) {
    if (event.key == 'Backspace')
      return;

    if (event.target.value && event.target.value.length > 0) {
      if (code == "0") {
        setTimeout(() => this.codeCtrl2.nativeElement.focus(), 0);
      }
      else if (code == "1") {
        setTimeout(() => this.codeCtrl3.nativeElement.focus(), 0);
      }
      else if (code == "2") {
        setTimeout(() => this.codeCtrl4.nativeElement.focus(), 0);
      }
    }
  }

  onBackSpace(code: string) {
    if (code == "3") {
      setTimeout(() => this.codeCtrl3.nativeElement.focus(), 0);
    }
    else if (code == "2") {
      setTimeout(() => this.codeCtrl2.nativeElement.focus(), 0);
    }
    else if (code == "1") {
      setTimeout(() => this.codeCtrl1.nativeElement.focus(), 0);
    }
  }

  checkCode() {
    if (!this.code1 || this.code1.length == 0) {
      this.isValid = false;
      return;
    }

    if (!this.code2 || this.code2.length == 0) {
      this.isValid = false;
      return;
    }

    if (!this.code2 || this.code3.length == 0) {
      this.isValid = false;
      return;
    }

    if (!this.code4 || this.code4.length == 0) {
      this.isValid = false;
      return;
    }

    this.isValid = true;

    var code = this.code1.toString() + this.code2.toString() + this.code3.toString() + this.code4.toString();
    if (this.signedInUser.TwoFactorCode != code) {
      this.isCodeMismatch = true;
      return;
    }

    this.authService.setSessionPostTwoFactorAuth(this.signedInUser, this.email);
    this.isCodeValidate.emit(true);
    this.activeModal.close();

  }

}
